<template>
<LoadError v-if="loadError && !isLoading" :message="loadError" @retry="loadInstructions" />
<Loading v-else-if="isLoading" label="Loading instructions?" />
<template v-else>

    <v-card width="auto" class="pa0" v-if="!isLoading">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
                    <div>
                        <small>Please tap the box below to view options.</small>
                        <select v-model="tabs" :items="sections" item-title="name" item-value="value" style="border: 1px dotted black; width: 100%;">
                        <option v-for="s, i in sections" :key="i" :value="s.value">{{ s.name }}</option>
                    </select>
                    </div>
                    <v-window :class="{'pa-8': !isMobile}" v-model="tabs">
                        <v-window-item v-for="section, i in sections" :key="i" :value="section.value">
                            <v-card variant="tonal">
                                <v-card-text style="overflow:scroll;max-height:40vh">
                                    <div v-for="data, index in section.data" :key="index">
                                        <div v-if="data.includes('@#!#~')" class="bubble left my-4">{{ data.split("@#!#~")[1] }}</div>
                                        <div v-if="data.includes('@#!#+')" class="bubble right my-4">{{ data.split("@#!#+")[1] }}</div>
                                        <span v-if="!data.includes('@#!#~') && !data.includes('@#!#+')">{{ data }}</span>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-window-item>
                    </v-window>
                </v-card-text>
            </v-card>
    <v-card v-else>
        <Loading />
    </v-card>

</template>
</template>
<script>
import { loadData } from '@/services/errors';

import axi from '../services/axi.js';

export default {
  name: 'InfoWindowComponent',
  methods: {
    async loadInstructions() {
      return loadData(this, async () => {
        const sources = {
          lost_deer_procedure: ['getLostDeerData', 'Lost Deer Procedure'],
          notifiable_diseases_procedure: ['getDiseasesData', 'Notifiable Diseases Procedure'],
          structures_reporting: ['getStructureData', 'Structures Reporting'],
          structures_inspection: ['getInspectionData', 'Structures Inspection'],
        };
        const source = sources[this.sheet_name];
        if (!source) throw new Error('Unknown instructions');
        const response = await axi[source[0]]();
        this.data = response.data.valueRanges[0]?.values || [];
        this.sections = this.data.map((row) => ({ name: row[0], value: row[1], data: row.slice(2) }));
        this.title = source[1];
      });
    },

    close() {
      this.$emit('close');
    },
  },
  props: {
    isMobile: null,
    sheet_name: null,
  },
  async beforeMount() {
    return this.loadInstructions();
  },
  data() {
    return {
      loadError: '',
      selected: null,
      articles: {},
      headers: null,
      isLoading: false,
      title: null,
      sections: [],
      sectionsconcat: null,
      data: null,
      tabs: null,
    };
  },
};
</script>